import { Component } from "react";
import { observer } from "mobx-react";

import type { Message } from "../models.ts";
import { ThinkingIndicator } from "./ThinkingIndicator.tsx";
import { ImgSearch } from "./Images/ImgSearch.tsx";
import { ImgDocumentCheck } from "./Images/ImgDocumentCheck.tsx";
import { ImgCancel } from "./Images/ImgCancel.tsx";
import { ImgWeb } from "./Images/ImgWeb.tsx";
import { ImgInProgress } from "./Images/ImgInProgress.tsx";

type ChatMessageSearchProgressProps = {
  message: Message;
};

@observer
export class ChatMessageSearchProgress extends Component<ChatMessageSearchProgressProps> {
  render() {
    const { toolProgress } = this.props.message;
    if (!toolProgress) return null;

    const { status, searchResults, sitesProcessing } = toolProgress;

    const currentSite = sitesProcessing?.slice().reverse().find(s => s.status === 'processing')
      || sitesProcessing?.[sitesProcessing.length - 1];
    const completedCount = sitesProcessing?.filter(s => s.status === 'completed').length || 0;
    const totalCount = sitesProcessing?.length || 0;

    return (
      <div className="search-progress">
        {status && !searchResults?.length && <div className="search-status">
          <ThinkingIndicator text={status} />
        </div>}

        {searchResults && searchResults.length > 0 && (
          <div className="search-results-compact">
            <span className="search-results-icon"><ImgSearch size={14} /></span>
            <span className="search-results-count">Found {searchResults.length} results</span>
            <div className="search-results-favicons">
              {searchResults.slice(0, 8).map((result, index) => (
                result.favicon && <img key={index} className="search-result-favicon" src={result.favicon} alt="" title={result.title} onError={(e) => { e.currentTarget.style.display = 'none'; }} />
              ))}
            </div>
          </div>
        )}

        {sitesProcessing && sitesProcessing.length > 0 && (
          <div className="sites-processing-compact">
            <div className="sites-icons-row">
              {sitesProcessing.map((site, index) => (
                <span key={index} className={`site-icon-wrapper ${site.status}`} title={`${site.title || new URL(site.link).hostname}: ${site.status}`}>
                  {site.favicon ? (
                    <img className="site-favicon" src={site.favicon} alt="" onError={(e) => { 
                      e.currentTarget.style.display = 'none';
                      e.currentTarget.parentElement?.classList.add('favicon-error');
                    }} />
                  ) : (
                    <span className="site-favicon-placeholder"><ImgWeb size={12} /></span>
                  )}
                  <span className="favicon-failback">{new URL(site.link).hostname.substring(0, 1).toUpperCase()}</span>
                  <span className={`site-status-dot ${site.status}`}></span>
                </span>
              ))}
            </div>
            {currentSite && (
              <div className="current-site-info">
                <span className="current-site-label">
                  {currentSite.status === 'processing' ? <ImgInProgress size={12} /> : currentSite.status === 'completed' ? <ImgDocumentCheck size={12} /> : <ImgCancel size={12} />}
                </span>
                <span className="current-site-name">{currentSite.title || new URL(currentSite.link).hostname}</span>
                <span className="sites-counter">({completedCount}/{totalCount})</span>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}
